import React from 'react';
import { ArrowRight } from './Icons';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
}
export function CTAButton({
  text = '¡SÍ! QUIERO RECUPERAR LA INFANCIA DE MI HIJO POR $13.99',
  subtext = '(Acceso inmediato al PDF tras el pago)',
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-8">
      <a href="#oferta" className="w-full md:w-auto bg-terracotta hover:bg-terracotta-dark text-white font-bold py-4 px-6 md:px-10 rounded-full shadow-xl transition-all duration-300 flex flex-col md:flex-row items-center justify-center gap-3 text-lg md:text-xl cta-pulse group no-underline" data-id="element-9">
        <span className="text-center" data-id="element-10">{text}</span>
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-11" />
      </a>
      {subtext && <p className="mt-3 text-sm text-warm-medium font-medium" data-id="element-12">{subtext}</p>}
    </div>;
}